import { render, staticRenderFns } from "./ListSelectedItemVehicle.vue?vue&type=template&id=48e0964c&scoped=true"
import script from "./ListSelectedItemVehicle.vue?vue&type=script&lang=js"
export * from "./ListSelectedItemVehicle.vue?vue&type=script&lang=js"
import style0 from "./ListSelectedItemVehicle.vue?vue&type=style&index=0&id=48e0964c&prod&lang=scss&scoped=true"
import style1 from "./ListSelectedItemVehicle.vue?vue&type=style&index=1&id=48e0964c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e0964c",
  null
  
)

export default component.exports